var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.54 41.89",
    style: {
      enableBackground: "new 0 0 41.54 41.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#93A0AA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.95,19.88H8.22c-1.52,0-2.76-1.24-2.76-2.76V8.39c0-1.52,1.24-2.76,2.76-2.76h8.73 c1.52,0,2.76,1.24,2.76,2.76v8.73C19.71,18.64,18.47,19.88,16.95,19.88z M8.22,7.42c-0.54,0-0.97,0.44-0.97,0.97v8.73 c0,0.54,0.44,0.97,0.97,0.97h8.73c0.54,0,0.97-0.44,0.97-0.97V8.39c0-0.54-0.44-0.97-0.97-0.97H8.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.33,19.88h-8.73c-1.52,0-2.76-1.24-2.76-2.76V8.39c0-1.52,1.24-2.76,2.76-2.76h8.73 c1.52,0,2.76,1.24,2.76,2.76v8.73C36.08,18.64,34.85,19.88,33.33,19.88z M24.59,7.42c-0.54,0-0.97,0.44-0.97,0.97v8.73 c0,0.54,0.44,0.97,0.97,0.97h8.73c0.54,0,0.97-0.44,0.97-0.97V8.39c0-0.54-0.44-0.97-0.97-0.97H24.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.33,36.26h-8.73c-1.52,0-2.76-1.24-2.76-2.76v-8.73c0-1.52,1.24-2.76,2.76-2.76h8.73 c1.52,0,2.76,1.24,2.76,2.76v8.73C36.08,35.02,34.85,36.26,33.33,36.26z M24.59,23.79c-0.54,0-0.97,0.44-0.97,0.97v8.73 c0,0.54,0.44,0.97,0.97,0.97h8.73c0.54,0,0.97-0.44,0.97-0.97v-8.73c0-0.54-0.44-0.97-0.97-0.97H24.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.95,36.26H8.22c-1.52,0-2.76-1.24-2.76-2.76v-8.73c0-1.52,1.24-2.76,2.76-2.76h8.73 c1.52,0,2.76,1.24,2.76,2.76v8.73C19.71,35.02,18.47,36.26,16.95,36.26z M8.22,23.79c-0.54,0-0.97,0.44-0.97,0.97v8.73 c0,0.54,0.44,0.97,0.97,0.97h8.73c0.54,0,0.97-0.44,0.97-0.97v-8.73c0-0.54-0.44-0.97-0.97-0.97H8.22z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.cd5b5abb.svg";
export { ForwardRef as ReactComponent };